import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PUBLIC_PATHS = [
  '/claim-handle', '/complete-profile', '/auth', '/auth/callback',
  '/login', '/signup', '/', '/terms', '/privacy', '/contact',
  '/dmca', '/community-guidelines', '/forgot-password', '/reset-password'
];

function isExempt(pathname) {
  return PUBLIC_PATHS.some(p => pathname === p || pathname.startsWith(p + '/'));
}

/**
 * Wrapper component that enforces:
 * 1. Handle claim (if missing)
 * 2. Neighborhood / profile completion (if missing)
 */
export function RequireHandle({ children }) {
  const { user, loading, needsProfileCompletion } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return children;
  if (isExempt(location.pathname)) return children;

  // Step 1: Handle required
  if (!user.handle && !user.has_handle) {
    return <Navigate to="/claim-handle" state={{ from: location }} replace />;
  }

  // Step 2: Neighborhood / profile completion required
  if (needsProfileCompletion) {
    return <Navigate to="/complete-profile" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireHandle;
